import React, { useRef } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/dist/DrawSVGPlugin";
import { SplitText } from "gsap/dist/SplitText";
import { registerGsapPlugins } from "lib/gsap";
import { DeterministicMatchingSvg } from "./deterministic-svg";

registerGsapPlugins(ScrollTrigger, SplitText, DrawSVGPlugin);

export function DeterministicAnimation() {
  const scope = useRef<HTMLDivElement>(null);
  const timeline = useRef<GSAPTimeline>();

  useGSAP(
    () => {
      timeline.current = gsap.timeline({
        scrollTrigger: {
          trigger: "#idr-deterministic-matching",
          toggleActions: "play reset restart reset",
        },
        delay: 0.5,
      });
      timeline.current
        .from(".node-group", {
          duration: 0.55,
          stagger: 0.45,
          ease: "power1.out",
          opacity: 0.6,
          transformOrigin: "center center",
        })
        .from(
          ".node-gradient",
          {
            opacity: 0.25,
            duration: 0.5,
            stagger: 0.35,
            ease: "power2.inOut",
          },
          "<+0.2",
        )
        .from(
          ".line",
          {
            duration: 0.75,
            stagger: 0.35,
            ease: "power2.inOut",
            drawSVG: "0",
          },
          "<+0.3",
        )
        .from(
          "#text-group",
          {
            duration: 0.05,
            opacity: 0,
          },
          "<+0.65",
        )
        .from(
          "#text-border",
          {
            duration: 0.55,
            ease: "power2.inOut",
            drawSVG: "0",
          },
          "<",
        )

        .from(
          "#text",
          {
            duration: 0.25,
            opacity: 0,
            ease: "power3.out",
          },
          "<",
        );
    },
    { scope },
  );

  return (
    <Box ref={scope}>
      <Flex flex={1} id="idr-deterministic-matching">
        <DeterministicMatchingSvg />
      </Flex>
    </Box>
  );
}
